import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { IMAGES, CONTACT } from '../utils/constants';

const Footer = () => {
  return (
    <footer className="footer bg-slate-950 text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="footer-brand">
            <img src={IMAGES.logo} alt="SolidCloud Logo" className="h-20 w-auto mb-6" />
            <p className="footer-tagline text-cream-200">
              Engineering materials for a lighter, safer, and more efficient future.
            </p>
          </div>

          <div className="footer-links">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-menu">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/technology">Technology</Link></li>
              <li><Link to="/applications">Applications</Link></li>
              <li><Link to="/vision">Founder's Vision</Link></li>
              <li><Link to="/collaboration">Collaboration</Link></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4 className="footer-title">Contact</h4>
            <div className="contact-info space-y-4">
              <div className="contact-item">
                <Mail className="contact-icon" />
                <div>
                  <p className="contact-label">General Inquiries</p>
                  <a href={`mailto:${CONTACT.generalEmail}`} className="contact-link">
                    {CONTACT.generalEmail}
                  </a>
                </div>
              </div>
              <div className="contact-item">
                <Mail className="contact-icon" />
                <div>
                  <p className="contact-label">Founder</p>
                  <a href={`mailto:${CONTACT.founderEmail}`} className="contact-link">
                    {CONTACT.founderEmail}
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-founder">
            <h4 className="footer-title">Leadership</h4>
            <p className="founder-name text-cream-100">{CONTACT.founderName}</p>
            <p className="founder-title text-cream-300 text-sm">Founder & Visionary</p>
          </div>
        </div>

        <div className="footer-bottom pt-8 border-t border-slate-800 text-center">
          <p className="text-cream-300 text-sm">
            © {new Date().getFullYear()} SolidCloud International. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
